module.exports = __webpack_public_path__ + "static/9-10e48d7332d7acb7c883f9069f234e91.png";